import { createReducer } from "@reduxjs/toolkit";
import type { UpdateState } from "@redux/state/shared-types";
import { documentaryResourceUpdate, documentaryResourceUpdateReset } from "./documentary-resource-update";

const initialState: UpdateState = { justUpdatedId: null, processing: "idle" };

export const documentaryResourceUpdateReducer = createReducer<UpdateState>(initialState, builder => {
  builder.addCase(documentaryResourceUpdate.fulfilled, (state, { payload }) => {
    return {
      ...state,
      justUpdatedId: payload,
      processing: "success",
    };
  });
  builder.addCase(documentaryResourceUpdate.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(documentaryResourceUpdate.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(documentaryResourceUpdateReset, () => {
    return initialState;
  });
});
